import { gql } from '@apollo/client';

import { User, UserPreference } from './user.model';

export const UserFragment = gql`
  fragment UserFields on User {
    _id
    email
    phoneNumber
    profile {
      name
      avatar
    }
    isActive
    accessibleStores
    deletedAt
    role
    permissions
    createdAt
    updatedAt
  }
`;

export const UserPreferenceFragment = gql`
  fragment UserPreferenceFields on UserPreference {
    _id
    lastCarrierServiceId
  }
`;

export const MeQuery = gql`
  query me {
    me {
      ...UserFields
    }
  }

  ${UserFragment}
`;

export interface MeQueryResult {
  me: User;
}

export const UserPreferenceQuery = gql`
  query userPreference {
    userPreference {
      ...UserPreferenceFields
    }
  }

  ${UserPreferenceFragment}
`;

export interface UserPreferenceQueryResult {
  userPreference: UserPreference;
}
